import { defineMessages } from 'react-intl';

export const scope = 'app.containers.Dashboard';

export default defineMessages({
  copiedToClipboard: {
    id: `${scope}.copied_to_clipboard`,
    defaultMessage: 'Copied to clipboard'
  },
  viewPayments: {
    id: `${scope}.view_payments`,
    defaultMessage: 'View Payments'
  },
  averageRating: {
    id: `${scope}.average_rating`,
    defaultMessage: 'Average Rating'
  },
  recentPayments: {
    id: `${scope}.recent_payments`,
    defaultMessage: 'Recent Payments'
  },
  lastSevenDays: {
    id: `${scope}.last_seven_days`,
    defaultMessage: 'Last 7 days'
  },
  totalTips: {
    id: `${scope}.total_tips`,
    defaultMessage: 'Total tips'
  },
  totalAllTime: {
    id: `${scope}.total_all_time`,
    defaultMessage: 'Total[All Time]'
  },
  unclaimedTips: {
    id: `${scope}.unclaimedTips`,
    defaultMessage:
      'You have {unremittedAmount} in unclaimed tips. Team tips are not paid out immediately so make sure to transfer them when you want the money moved to your preferred payout method.'
  },
  remitSuccessful: {
    id: `${scope}.remitSuccessful`,
    defaultMessage:
      'Successful! Your balance will be transferred via your preferred payment method shortly'
  },
  transferButton: {
    id: `${scope}.transferButton`,
    defaultMessage: 'Transfer Tips'
  },
  completeKYC: {
    id: `${scope}.completeKYC`,
    defaultMessage: 'Complete KYC'
  },
  takePayment: {
    id: `${scope}.takePayment`,
    defaultMessage: 'Take a Payment'
  },
  activityOverview: {
    id: `${scope}.activity_overview`,
    defaultMessage: 'Activity Overview'
  },
  payoutAndBalance: {
    id: `${scope}.payout_and_balance`,
    defaultMessage: 'Payout & Balance'
  },
  copyTipLink: {
    id: `${scope}.copy_tip_link`,
    defaultMessage: 'Copy Tip Link'
  },
  vsPreviousWeek: {
    id: `${scope}.vs_previous_week`,
    defaultMessage: 'vs previous week'
  },
  scanToTip: {
    id: `${scope}.scan_to_tip`,
    defaultMessage: 'Scan to leave a tip'
  },
  scanToReview: {
    id: `${scope}.scan_to_review`,
    defaultMessage: 'Scan to leave a review'
  },
  showQrToGuest: {
    id: `${scope}.show_qr_to_guest`,
    defaultMessage: 'Show this QR code to a guest so they can scan it with their phone camera.'
  }
});
